import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown } from "react-icons/fa"; // Optional icon for dropdown arrow
import Button from "./Button"; // Your existing Button component


function Dropdown({ options = [], selectedValue, onChange, className, openPosition = "bottom", useAsPopover = false, label='', disabled = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // Ref for the dropdown container

  // Toggle the dropdown open/close state
  const toggleDropdown = () => {
    if (disabled) return;
    setIsOpen((prev) => !prev);
  };

  // Handle option selection
  const handleSelect = (value) => {
    if (disabled) return;
    setIsOpen(false);
    onChange(value);
  };

  // Close the dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  // Determine label for the selected option
  const selectedLabel =
    options.find((opt) => opt.value === selectedValue)?.label || "Select";

  // Dropdown positioning classes based on `openPosition` prop
  const positionClasses =
    openPosition === "top"
      ? "absolute left-0 bottom-full mb-2"
      : "absolute left-0 top-full mt-2";

  return (
    <div className={`relative inline-block w-auto ${className}`} ref={dropdownRef}>
      {/* Dropdown Button */}
      <Button
        type="outline"
        onClick={toggleDropdown}
        className="w-full flex justify-between items-center"
        disabled={disabled}
      >
        {useAsPopover? label: selectedLabel} 
        <FaChevronDown className="ml-2" />
      </Button>

      {/* Dropdown Menu */}
      {isOpen && !disabled && (
        <div
          className={`w-[200px] bg-white border border-gray-300 rounded-lg shadow-lg z-10 ${positionClasses}`}
        >
          <ul className="py-2">
            {options.map((option) => (
              <li
                key={option.value}
                onClick={() => handleSelect(option.value)}
                className={`px-4 py-2 hover:bg-blue-100 cursor-pointer ${
                  selectedValue === option.value ? "bg-blue-50 font-semibold" : ""
                }`}
              >
                {option.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default Dropdown;